import React from "react";
import ConsolidatedSettlementSummaryTable from "./ConsolidatedSettlementSummaryTable";

const ConsolidatedSettlementSummaryList = () => {
  return (
    <div className="container-fluid admin-module-page py-4">
      <div className="admin-page-header d-flex justify-content-between align-items-start flex-wrap gap-3 mb-4">
        <div>
          <span className="admin-page-kicker">Hotel Management</span>
          <h3 className="admin-page-title fw-bold mb-1">Settlement Summary Report</h3>
          <p className="admin-page-description mb-0">
            View consolidated payment and refund transactions for the selected date range.
          </p>
        </div>
      </div>
      <ConsolidatedSettlementSummaryTable />
    </div>
  );
};

export default ConsolidatedSettlementSummaryList;
